import axios, { AxiosResponse } from 'axios';
import { createRequestConfig } from './utils';
import EqTrouble from '../models/data/EqTrouble';
import EqTroubleRequest, {
  EqTroubleDetailRequest,
} from '../models/requests/GetEqTrouble';

// 設備故障情報の取得関数
export default function requestEqTroubleList(
  url: string,
  params?: EqTroubleRequest,
): Promise<AxiosResponse<EqTrouble[]>> {
  const config = createRequestConfig({ params });
  return axios.get<EqTrouble[]>(url, config);
}

// 設備故障情報件数の取得関数
export function requestCountEqTrouble(
  url: string,
  params?: EqTroubleRequest,
): Promise<AxiosResponse<number>> {
  const config = createRequestConfig({ params });
  return axios.get<number>(url, config);
}

// 設備故障の詳細情報の取得関数
export function requestEqTroubleDetail(
  url: string,
  params?: EqTroubleDetailRequest,
): Promise<AxiosResponse<EqTrouble>> {
  const config = createRequestConfig({ params });
  return axios.get<EqTrouble>(url, config);
}
